import type { AudioFormat } from '../../api/cc-smarts/getAudio';
import { audioPlayerState } from '../state/AudioPlayerState';

export function getRequestParamsForAudioPlayer({
	activationId,
	product,
	cloudId,
	locale,
	format,
	overrideSupportingContent,
}: {
	activationId: string;
	product: string;
	cloudId: string;
	locale: string;
	format: AudioFormat;
	overrideSupportingContent?: string[];
}) {
	const {
		activeContent: { contentId, contentType, supportingContent },
		activeFeature,
		customization,
	} = audioPlayerState.get();

	return {
		activationId,
		product,
		cloudId,
		locale,
		contentId,
		contentType,
		type: activeFeature,
		format,
		instructions: customization,
		supportingResourceARIs:
			overrideSupportingContent || supportingContent.map((resource) => resource.ari),
	};
}
